import { BrowserRouter } from 'react-router';
import { AppProviders } from './providers';
import { AppRoutes } from './router';
import './app.css';

export function App() {
  return (
    <AppProviders>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </AppProviders>
  );
}
